import type { RouteRequest, RouteResponse, ProfileInfo, GeocodeResult, PrecomputeRequest, PrecomputeResponse } from '../types/api';

const API_BASE = process.env.REACT_APP_API_URL || '';

export async function planRoute(request: RouteRequest, explore: boolean = false): Promise<RouteResponse> {
  const qs = explore ? '?explore=true' : '';
  const res = await fetch(`${API_BASE}/api/route${qs}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || 'Route planning failed');
  }
  return res.json();
}

// Precompute a bundle of routes across a sampled weight grid for a fixed OD pair.
// The frontend scrubs sliders client-side and picks the nearest bundle entry,
// giving instant feedback without a network round-trip per slider move.
export async function precomputeRoutes(request: PrecomputeRequest, explore: boolean = false): Promise<PrecomputeResponse> {
  const qs = explore ? '?explore=true' : '';
  const res = await fetch(`${API_BASE}/api/route/precompute${qs}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || 'Precompute failed');
  }
  return res.json();
}

export async function fetchProfiles(): Promise<ProfileInfo[]> {
  const res = await fetch(`${API_BASE}/api/profiles`);
  if (!res.ok) throw new Error('Failed to load profiles');
  return res.json();
}

export async function geocode(query: string, limit: number = 8, near: { lat: number; lon: number } | null = null): Promise<GeocodeResult[]> {
  if (!query || query.trim().length < 3) return [];
  const params = new URLSearchParams({ q: query, limit: String(limit) });
  if (near) {
    params.set('lat', String(near.lat));
    params.set('lon', String(near.lon));
  }
  const res = await fetch(`${API_BASE}/api/geocode?${params}`);
  if (!res.ok) return [];
  return res.json();
}